import type { SelectFieldOption } from '@/components/inputs/CustomSelectField'
import type { ControllerConfigVersion } from '@/features/controller/configuration/types'
import { renderTimestamp } from '@/features/controller/utils/renderTimestamp'

export function renderConfigVersionShortId(configVersion: ControllerConfigVersion) {
  const id = configVersion.id
  return id.replace(/-.*/, '')
}

export function renderConfigVersionName(configVersion: ControllerConfigVersion) {
  return renderTimestamp(configVersion.createdAt)
}

export function renderConfigVersionSelectOption(configVersion: ControllerConfigVersion): SelectFieldOption<string> {
  return { id: configVersion.id, label: renderConfigVersionName(configVersion), value: configVersion.id }
}
